import { Component } from '@angular/core';

@Component({
  selector: 'em-worklist-page',
  styleUrls: ['./worklist-page.component.less'],
  templateUrl: './worklist-page.component.html',
  standalone: false,
})
export class WorklistPageComponent {}
